<template>
    <div class="contain desPro">
        <div class="header-box">
            变更及签证管理
        </div>
        <div class="box">
            <div class="build-bar">
                <span>项目名称：</span>
                <el-input placeholder="请输入项目名称" v-model="search.name" style="width:12vw;"></el-input>
                <el-button type="primary" class="add-user" @click="doFilter" style="margin-left:1vw;">查询</el-button>
                <!-- <el-button type="primary" class="add-user" @click="addFun">项目创建</el-button> -->
            </div>
            <div class="box-content">
                <el-table
                    :data="listData"
                    border
                    stripe
                    height="100%"
                    style="width: 100%;"
                >
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column label="序号" width="60">
                        <template slot-scope="scope">
                            <span>{{ scope.row.index }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="项目名称">
                        <template slot-scope="scope">
                            <span>{{ scope.row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="位置">
                        <template slot-scope="scope">
                            <span>{{ scope.row.address }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="描述">
                        <template slot-scope="scope">
                            <span>{{ scope.row.note }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="效果图">
                        <template slot-scope="scope">
                            <el-image v-for="item in scope.row.imgList" :key="item" style="width: 50px; height: 50px" :src="item" :preview-src-list="scope.row.imgList"></el-image>
                            <!-- <span>{{ scope.row.remarks }}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="创建人">
                        <template slot-scope="scope">
                            <span>{{ scope.row.userName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间">
                        <template slot-scope="scope">
                            <span>{{ scope.row.createDate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
                            <!-- <el-button type="text" style="color:#E6A23C;" @click="modeFun(scope.$index, scope.row)">修改</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 表单列表 -->
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[3, 5, 10, 20]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
                style="padding-top:10px;"
                ></el-pagination>


                <el-dialog
                    :title="diaTitle"
                    :visible.sync="addFormVisible"
                    width="500px"
                    center
                    :append-to-body="true"
                    :lock-scroll="false"
                    class="add-form"
                >
                    <el-form :model="addForm" ref="addForm" :rules="rules" label-width="100px" :label-position="labelPosition">
                        <el-form-item label="项目名称：" prop="name">
                            <el-input v-model="addForm.name" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="位置：">
                            <el-input v-model="addForm.address" autocomplete="off"></el-input>
                        </el-form-item>
                        </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="addFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
    data(){
        return{
            search:{
                name:'',
            },
            listData:[],
            groupId:"",
            num:{},
            dataText:"数据加载中...",
            addFormVisible:false,
            addForm: {
                id:'',
                name:'',
                address:'',
                userId:'',
                userName:'',
                groupId:''
            },
            rules:{
                name: [
                { required: true, message: '请输入相应内容', trigger: 'blur' }
                ],
            },
            currentPage: 1,
            pageSize: 10,
            totalItems: 0,
            diaTitle:"创建项目",
            labelPosition: 'right',
        }
    },
    mounted() {
        this.groupId = this.$store.state.groupId;
        if(''==this.groupId){
            this.$store.commit('setGroupId');
            this.groupId = this.$store.state.groupId;
        }
        this.getData()
    },
    methods:{
        doFilter(){
            this.getData()
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentChangePage()
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.currentChangePage();
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getData();
        },
        //点击过滤
        showProjectFun(index){
            this.search.unit = index
            this.getData()
        },
        //获取数据
        getData(){
            var that = this
            this.search.groupId = this.groupId
            this.search.pageNum = this.currentPage
            this.search.pageSize = this.pageSize
            myHttp.getEntProjectList(this.search).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.entProject.list;
                    for(var i=0;i<list.length;i++){
                        list[i].index = list[i].index = ((that.currentPage - 1) * that.pageSize)+(i+1);
                        var img = list[i].effectImage&&list[i].effectImage!=''?list[i].effectImage.split(','):[]
                        for(var j=0;j<img.length;j++){
                            img[j] = base.httpCtx+img[j]
                        }
                        list[i].imgList = img
                    }
                    that.listData = list;
                    that.totalItems = resp.data.data.entProject.total
                    if(that.listData.length==0){
                        that.dataText = "暂无数据"
                    }
                }
            })
        },
        //导出
        // exportOut(){
        //     var token = this.$store.state.token;
        //     window.open(myHttp.getExportInspectsByGroupId+'?groupId='+this.groupId+'&unit='+this.search.unit+'&date='+this.search.date+'&accessToken='+token)
        // },
        //查看
        handleEdit(index,row){
            this.$router.push('/changeFile/'+row.id)
        },
        // 新增的数据
        sumbitAddRow(formName) {
            var that = this;
            this.addForm.userId = this.$store.state.user.id
            this.addForm.userName = this.$store.state.user.name
            this.addForm.groupId = this.groupId
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(that.addForm.id==''){
                        myHttp.postEntProject(that.addForm).then(function(resp){
                            if(resp.data.code=="200"){
                                that.$message.success("添加成功");
                                that.addFormVisible = false;
                                that.currentPage = 1;
                                that.getData();
                            }else{
                                that.$message.error(resp.data.msg);
                            }
                        },function(){});
                    }else{
                        myHttp.putEntProject(that.addForm).then(function(resp){
                            if(resp.data.code=="200"){
                                that.$message.success("添加成功");
                                that.addFormVisible = false;
                                that.currentPage = 1;
                                that.getData();
                            }else{
                                that.$message.error(resp.data.msg);
                            }
                        },function(){});
                    }
                }
            });
        },
        //新增
        addFun(){
            this.addForm.id = ''
            this.addForm.name = ''
            this.addForm.address = ''
            this.addFormVisible = true
            this.diaTitle = '项目创建'
        },
        //修改
        modeFun(index,row){
            this.addFormVisible = true
            this.addForm.id = row.id
            this.addForm.name = row.name
            this.addForm.address = row.address
            this.diaTitle = '项目修改'
        },
    }
}
</script>
<style scoped>
    .contain{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header-box{
        padding: 15px 20px;
        height: 70px;
        width: 100%;
        box-shadow: 1px 2px 3px 2px #ddd;
        background: #fff;
        box-sizing: border-box;
        position: relative;
        text-align: left;
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #2058D9;
    }
    .box{
        margin-top: 15px;
        width: 100%;
        height: calc( 100% - 85px );
        background: #fff;
    }
    .box-content{
        width: 100%;
        height: calc( 100% - 140px );
        background: #fff;
    }
    .build-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 80px;
        background: #fff;
        border-bottom: 3px solid #17b2fe;
        padding: 0 20px;
    }
    
</style>
<style>
    .build-bar span{
        margin-left: 0;
    }
    .el-table td, .el-table th{
        text-align: center;
    }
    /* .el-dialog{
        width: 500px;
    } */
</style>